import projectIcon1 from 'assets/images/default_project_picture_icons/1_256.png';
import projectIcon2 from 'assets/images/default_project_picture_icons/2_256.png';
import projectIcon3 from 'assets/images/default_project_picture_icons/3_256.png';
import projectIcon4 from 'assets/images/default_project_picture_icons/4_256.png';

const COVER_PICTURE_ICONS: Record<string, string> = {
    'default_cover_picture1.png': projectIcon1,
    'default_cover_picture2.png': projectIcon2,
    'default_cover_picture3.png': projectIcon3,
    'default_cover_picture4.png': projectIcon4,
};

export const coverPictureToIcon = (coverPicture?: string | null): string => (
    COVER_PICTURE_ICONS[coverPicture ?? ''] ?? projectIcon1
);
